'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:SchedulesCtrl
 * @description
 * # SchedulesCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('SchedulesCtrl', function (cfpLoadingBar, $rootScope, $location, $uibModal,
    $route, scheduleService, AuthenticationService, FlashService, modalService) {

      var schedulesVm = this;
      var fetchMySchedules = $route.current.action === 'personalise';
      schedulesVm.activate = activate;
      schedulesVm.select = select;
      schedulesVm.edit = edit;
      schedulesVm.remove = remove;
      schedulesVm.clearSelection = clearSelection;
      schedulesVm.scheduleList = [];
      schedulesVm.selected = [];
      schedulesVm.modalOptions = {};
      schedulesVm.inprogress = false;
      schedulesVm.hasSelection = false;
      schedulesVm.fetchMySchedules = fetchMySchedules;

      activate();


      function activate() {
        cfpLoadingBar.start();
        var schedules = fetchMySchedules ?
          scheduleService.getUserSchedules() :
          scheduleService.GetAll();

        schedules
        .then(function(response) {
          if (response !== null) {
            schedulesVm.scheduleList = response;
            angular.forEach(schedulesVm.scheduleList, function(value) {
              value.selected = false;
            });
          }
        }, function(error) {
          if (error.status === 401) {
            AuthenticationService.Logout();
          }
          FlashService.Error('Network Error. Try reloading the page', false);
        }).
        finally(function() {
          cfpLoadingBar.complete();
        });
      }

      function select(schedule) {
        if (schedule.selected) {
          var removeIndex = schedulesVm.selected.indexOf(schedule.id);
          schedulesVm.selected.splice(removeIndex, 1);
        } else {
          schedulesVm.selected.push(schedule.id);
        }

        schedule.selected = !schedule.selected;
        schedulesVm.hasSelection = schedulesVm.selected.length > 0;
        // schedule.selected = true;
      }

      function clearSelection() {
        angular.forEach(schedulesVm.scheduleList, function(value) {
          value.selected = false;
        });

        schedulesVm.selected = [];
        schedulesVm.hasSelection = schedulesVm.selected.length > 0;
      }

      function edit(schedule) {

      }

      function remove(schedule) {
        var scheduleName = schedule.monthYearFor;
        schedulesVm.modalOptions = {
          closeButtonText: 'Cancel',
          actionButtonText: 'Delete Schedule',
          headerText: 'Delete ' + scheduleName + '?',
          bodyText: 'Are you sure you want to delete this schedule?'
        };

        modalService.showModal({}, schedulesVm.modalOptions).then(function(result) {
          schedulesVm.inprogress = true;
          cfpLoadingBar.start();
          scheduleService.Delete(schedule.id).then(function(response) {
            var index = schedulesVm.scheduleList.indexOf(schedule);
            schedulesVm.scheduleList.splice(index, 1);
            FlashService.Success('Schedule for ' +schedule.monthYearFor + ' has been deleted', false);
          }, function(error) {
            if (error.status === 401) {
              AuthenticationService.Logout();
            }
            FlashService.Error('Could not delete schedule', false);
          }).
          finally(function() {
            cfpLoadingBar.complete();
            schedulesVm.inprogress = false;
          });
        });
      }

      return schedulesVm;
  });
